webpackJsonp([2,17],{

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(239),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(406),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37c53c7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDlDMTYuNTUyMyA5IDE3IDguNTUyMjggMTcgOEMxNyA3LjQ0NzcyIDE2LjU1MjMgNyAxNiA3TDE2IDlaTTAuMjkyODkzIDcuMjkyODlDLTAuMDk3NjMxIDcuNjgzNDIgLTAuMDk3NjMxMSA4LjMxNjU4IDAuMjkyODkzIDguNzA3MTFMNi42NTY4NSAxNS4wNzExQzcuMDQ3MzggMTUuNDYxNiA3LjY4MDU0IDE1LjQ2MTYgOC4wNzEwNyAxNS4wNzExQzguNDYxNTkgMTQuNjgwNSA4LjQ2MTU5IDE0LjA0NzQgOC4wNzEwNyAxMy42NTY5TDIuNDE0MjEgOEw4LjA3MTA3IDIuMzQzMTVDOC40NjE1OSAxLjk1MjYyIDguNDYxNTkgMS4zMTk0NiA4LjA3MTA3IDAuOTI4OTMxQzcuNjgwNTQgMC41Mzg0MDcgNy4wNDczOCAwLjUzODQwNyA2LjY1Njg1IDAuOTI4OTMxTDAuMjkyODkzIDcuMjkyODlaTTE2IDdMMSA3TDEgOUwxNiA5TDE2IDdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgN0MwLjQ0NzcxNSA3IDAgNy40NDc3MiAwIDhDMCA4LjU1MjI4IDAuNDQ3NzE1IDkgMSA5VjdaTTE2LjcwNzEgOC43MDcxMUMxNy4wOTc2IDguMzE2NTggMTcuMDk3NiA3LjY4MzQyIDE2LjcwNzEgNy4yOTI4OUwxMC4zNDMxIDAuOTI4OTMyQzkuOTUyNjIgMC41Mzg0MDggOS4zMTk0NiAwLjUzODQwOCA4LjkyODkzIDAuOTI4OTMyQzguNTM4NDEgMS4zMTk0NiA4LjUzODQxIDEuOTUyNjIgOC45Mjg5MyAyLjM0MzE1TDE0LjU4NTggOEw4LjkyODkzIDEzLjY1NjlDOC41Mzg0MSAxNC4wNDc0IDguNTM4NDEgMTQuNjgwNSA4LjkyODkzIDE1LjA3MTFDOS4zMTk0NiAxNS40NjE2IDkuOTUyNjIgMTUuNDYxNiAxMC4zNDMxIDE1LjA3MTFMMTYuNzA3MSA4LjcwNzExWk0xIDlIMTZWN0gxVjlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40a2ff84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiByeD0iMzAiIGZpbGw9IiM1NTU1RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMS40MjM4IDE3LjU2ODFDMzEuNzc1MiAxNy43MzI2IDMxLjk5OTcgMTguMDg1NiAzMS45OTk3IDE4LjQ3MzZWNDIuMTU3OUMzMS45OTk3IDQyLjU0NTkgMzEuNzc1MiA0Mi44OTg5IDMxLjQyMzggNDMuMDYzNEMzMS4wNzI1IDQzLjIyOCAzMC42NTc2IDQzLjE3NDUgMzAuMzU5NSA0Mi45MjYxTDIyLjc0MjkgMzYuNTc4OUgyMC40NzM0QzE4LjQ2NzcgMzYuNTc4OSAxNi44NDE4IDM0Ljk1MyAxNi44NDE4IDMyLjk0NzNWMjcuNjg0MkMxNi44NDE4IDI1LjY3ODUgMTguNDY3NyAyNC4wNTI2IDIwLjQ3MzQgMjQuMDUyNkgyMi43NDI5TDMwLjM1OTUgMTcuNzA1NEMzMC42NTc2IDE3LjQ1NyAzMS4wNzI1IDE3LjQwMzUgMzEuNDIzOCAxNy41NjgxWk0zOC4xODczIDIxLjcxMzlDMzguNTc3OCAyMS4zMjM0IDM5LjIxMSAyMS4zMjM0IDM5LjYwMTUgMjEuNzEzOUM0MS44NTc0IDIzLjk2OTggNDIuNTI2IDI3LjU5MjQgNDIuNTI2IDMwLjMxNThDNDIuNTI2IDMzLjAzOTEgNDEuODU3NCAzNi42NjE3IDM5LjYwMTUgMzguOTE3NkMzOS4yMTEgMzkuMzA4MSAzOC41Nzc4IDM5LjMwODEgMzguMTg3MyAzOC45MTc2QzM3Ljc5NjggMzguNTI3MSAzNy43OTY4IDM3Ljg5MzkgMzguMTg3MyAzNy41MDM0QzM5Ljg3ODggMzUuODExOSA0MC41MjYgMzIuODU1NSA0MC41MjYgMzAuMzE1OEM0MC41MjYgMjcuNzc2IDM5Ljg3ODggMjQuODE5NiAzOC4xODczIDIzLjEyODFDMzcuNzk2OCAyMi43Mzc2IDM3Ljc5NjggMjIuMTA0NCAzOC4xODczIDIxLjcxMzlaTTM0LjI0IDI1LjY2MTJDMzQuNjMwNSAyNS4yNzA3IDM1LjI2MzcgMjUuMjcwNyAzNS42NTQyIDI1LjY2MTNDMzYuNTMyOCAyNi41Mzk5IDM3LjI2MjggMjguMTI3OCAzNy4yNjI4IDMwLjMxNThDMzcuMjYyOCAzMi41MDM3IDM2LjUzMjggMzQuMDkxNiAzNS42NTQyIDM0Ljk3MDJDMzUuMjYzNiAzNS4zNjA3IDM0LjYzMDUgMzUuMzYwNyAzNC4yNCAzNC45NzAyQzMzLjg0OTQgMzQuNTc5NyAzMy44NDk0IDMzLjk0NjUgMzQuMjQgMzMuNTU2QzM0LjY3NzEgMzMuMTE4OSAzNS4yNjI4IDMyLjA3NTIgMzUuMjYyOCAzMC4zMTU4QzM1LjI2MjggMjguNTU2MyAzNC42NzcxIDI3LjUxMjYgMzQuMjM5OSAyNy4wNzU1QzMzLjg0OTQgMjYuNjg0OSAzMy44NDk0IDI2LjA1MTggMzQuMjQgMjUuNjYxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return settingsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




var getSettings = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var settings;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!window.localStorage.engsettings) {
              _context.next = 6;
              break;
            }

            settings = JSON.parse(window.localStorage.engsettings);

            console.log("GOT SETTINGS FROM LOCALSTORAGE");

            return _context.abrupt("return", settings);

          case 6:
            console.log("WAS MADE");
            window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([true, true]));

          case 8:
            return _context.abrupt("return", [true, true]);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getSettings() {
    return _ref.apply(this, arguments);
  };
}();

var setSettings = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(newsetting) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (window.localStorage.engsettings) {
              window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newsetting));
            } else {
              window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([true, true]));
            }

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function setSettings(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var settingsService = {
  getSettings: getSettings,
  setSettings: setSettings
};

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(223),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-245f8eaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrowIconPath; });
var getArrowIconPath = function getArrowIconPath(languageDirection) {

    var arrowIconNext = void 0;
    var arrowIconPrevious = void 0;

    if (languageDirection === 'rtl') {
        arrowIconNext = __webpack_require__(205).default;
        arrowIconPrevious = __webpack_require__(206).default;
    } else {
        arrowIconNext = __webpack_require__(206).default;
        arrowIconPrevious = __webpack_require__(205).default;
    }

    return {
        arrowIconNext: arrowIconNext,
        arrowIconPrevious: arrowIconPrevious
    };
};

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAyNCAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE2NV8xMDA5NikiPgo8cGF0aCBkPSJNMTIuNjE1OCAyMy41MTk1TDExLjk0NzkgMjIuOTI0NUwxMS4yODI0IDIzLjUyMjJMMSAzMi43NTc3TDEgMUwyMyAxTDIzIDMyLjc2OTlMMTIuNjE1OCAyMy41MTk1WiIgZmlsbD0iI0ZGNTU3NCIgc3Ryb2tlPSIjRkY1NTc0IiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTE3LjMzMjEgOS4wOTg1MkMxNi44NTkyIDguNjMzODMgMTYuMDk3NCA4LjYzMzgzIDE1LjYyNzggOS4wOTg1MkwxMC4zNDk5IDE0LjMyNzJMOC4zNzI0NiAxMi4zNzJDNy44OTk1NCAxMS45MDczIDcuMTM3NyAxMS45MDczIDYuNjY4MTEgMTIuMzcyQzYuMTk4NTIgMTIuODQgNi4xOTg1MiAxMy41OTM5IDYuNjY4MTEgMTQuMDU4Nkw5LjM4MzI0IDE2Ljc0M0M5LjQxNTcxIDE2Ljc4NSA5LjQ1MTUyIDE2LjgyNjIgOS40OTA2NSAxNi44NjQ5QzkuNzc4NzMgMTcuMTUgMTAuMTc1OSAxNy4yNjEyIDEwLjU0NzIgMTcuMTk4NkMxMC43OTAzIDE3LjE2MDcgMTEuMDI0MyAxNy4wNDk1IDExLjIxMDggMTYuODY0OUMxMS4yNDk5IDE2LjgyNjIgMTEuMjg1OCAxNi43ODUgMTEuMzE4MiAxNi43NDIyTDE3LjMzMjEgMTAuNzg1MUMxNy44MDE3IDEwLjMxNzEgMTcuODAxNyA5LjU2MzIyIDE3LjMzMjEgOS4wOTg1MloiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTY1XzEwMDk2Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjM1IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=");

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(217);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("f5ffd5f0", content, true, {});

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/VideoPlayer.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;CACpB","file":"VideoPlayer.vue","sourcesContent":["\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    vidSrc: {
      default: ""
    }
  },
  data: function data() {
    return {
      height: "250px"
    };
  },
  mounted: function mounted() {
    // setTimeout(() => {
    //   this.height = (this.$refs.videoIframe.clientWidth / 16) * 9 + "px";
    //   console.log(this.height);
    // }, 2000);
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VideoPlayer"
  }, [_c('iframe', {
    ref: "videoIframe",
    attrs: {
      "src": _vm.vidSrc,
      "height": _vm.height,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(221);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("7be071af", content, true, {});

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n@-webkit-keyframes spin {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes spin-data-v-245f8eaa {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n.slinky-loader[data-v-245f8eaa] {\n  position: relative;\n  margin-top: 20px;\n  width: 40px;\n  aspect-ratio: 1;\n  border: 5px solid #555fff;\n  -webkit-animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n          animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n  border-radius: 50%;\n}\n.slinky-loader[data-v-245f8eaa]::after {\n  position: absolute;\n  content: \"\";\n  width: 30%;\n  aspect-ratio: 1;\n  top: 50%;\n  left: 100%;\n  -webkit-transform: translate(-25%, -50%);\n          transform: translate(-25%, -50%);\n  background: white;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/Slinky.vue"],"names":[],"mappings":";AACA;AACA;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,sEAAsE;UAC9D,8DAA8D;EACtE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,yCAAyC;UACjC,iCAAiC;EACzC,kBAAkB;CACnB","file":"Slinky.vue","sourcesContent":["\n@-webkit-keyframes spin {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes spin-data-v-245f8eaa {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n.slinky-loader[data-v-245f8eaa] {\n  position: relative;\n  margin-top: 20px;\n  width: 40px;\n  aspect-ratio: 1;\n  border: 5px solid #555fff;\n  -webkit-animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n          animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n  border-radius: 50%;\n}\n.slinky-loader[data-v-245f8eaa]::after {\n  position: absolute;\n  content: \"\";\n  width: 30%;\n  aspect-ratio: 1;\n  top: 50%;\n  left: 100%;\n  -webkit-transform: translate(-25%, -50%);\n          transform: translate(-25%, -50%);\n  background: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Slinky"
});

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slinky-loader"
  })
},staticRenderFns: []}

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MS42NCA1OC4yIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6IzExOTtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOmJldmVsO3N0cm9rZS13aWR0aDoxMXB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjUuNSIgeTE9IjI4Ljk4IiB4Mj0iNzcuODMiIHkyPSIyOC45OCIvPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjYyLjY1IiB5MT0iNTAuNDIiIHgyPSI4My44NyIgeTI9IjI5LjIiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI2Mi4xOSIgeTE9IjcuNzgiIHgyPSI4My40MSIgeTI9IjI5Ii8+PC9nPjwvZz48L3N2Zz4=");

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("341b2bf2", content, true, {});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAyNCAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjYxNjYgMjMuNTczNkwxMS45NDc5IDIyLjk3NjVMMTEuMjgxNiAyMy41NzYzTDEgMzIuODMxM0wxIDFMMjMgMUwyMyAzMi44NDM2TDEyLjYxNjYgMjMuNTczNloiIHN0cm9rZT0iI0ZGNTU3NCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "#progressBar{position:relative;top:-7px}.slider::-moz-range-thumb{width:20px;height:20px;border-radius:50%;background:#555fff;cursor:pointer}.slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:20px;height:20px;background:#555fff;border-radius:50%;cursor:pointer}.disabledBtn{display:none}.audio-player-container{display:flex;align-items:center;justify-content:center;gap:8px}.speed-btn{background:var(--bg-primary, #555fff);color:#fff;border:none;border-radius:16px;padding:4px 8px;font-size:12px;font-weight:500;min-width:36px;height:24px;cursor:pointer;transition:all .2s ease;user-select:none}.speed-btn:hover{background:var(--bg-primary-hover, #4444ee);transform:scale(1.05)}.speed-btn:active{transform:scale(0.95)}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/AudioPlayer.scss"],"names":[],"mappings":"AAAA,aACE,kBAEA,QAAA,CAGF,0BACE,WACA,YACA,kBAEA,mBACA,cAAA,CAGF,8BACE,wBACA,gBACA,WACA,YACA,mBACA,kBACA,cAAA,CA4DF,aACE,YAAA,CAGF,wBACE,aACA,mBACA,uBACA,OAAA,CAGF,WACE,sCACA,WACA,YACA,mBACA,gBACA,eACA,gBACA,eACA,YACA,eACA,wBACA,gBAAA,CAEA,iBACE,4CACA,qBAAA,CAGF,kBACE,qBAAA,CAAA","file":"AudioPlayer.scss","sourcesContent":["#progressBar {\n  position: relative;\n  // top: -9px;\n  top: -7px;\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n\n  background: #555fff;\n  cursor: pointer;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #555fff;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n// input[type=\"range\"] {\n//   -webkit-appearance: none;\n//   // margin-right: 15px;\n//   width: 120px;\n//   height: 7px;\n//   background: #aaabbb;\n//   border-radius: 5px;\n//   background-position: right center;\n//   background-image: linear-gradient(#7070af, #111199);\n//   background-size: 0% 100%;\n//   background-repeat: no-repeat;\n// }\n\n// input[type=\"range\"]::-webkit-slider-thumb {\n//   -webkit-appearance: none;\n//   height: 15px;\n//   width: 15px;\n//   border-radius: 50%;\n//   background: #555fff;\n//   cursor: ew-resize;\n//   box-shadow: 0 0 2px 0 #555;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// input[type=\"range\"]::-moz-range-thumb {\n//   -webkit-appearance: none;\n//   height: 15px;\n//   width: 15px;\n//   border-radius: 50%;\n//   background: #555fff;\n//   cursor: ew-resize;\n//   box-shadow: 0 0 2px 0 #390b8d;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// input[type=\"range\"]::-webkit-slider-runnable-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: transparent;\n// }\n\n// input[type=\"range\"]::-moz-range-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: transparent;\n// }\n\n// NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE\n// .slider::-webkit-slider-runnable-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: blue;\n// }\n\n.disabledBtn {\n  display: none;\n}\n\n.audio-player-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.speed-btn {\n  background: var(--bg-primary, #555fff);\n  color: white;\n  border: none;\n  border-radius: 16px;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 36px;\n  height: 24px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n  \n  &:hover {\n    background: var(--bg-primary-hover, #4444ee);\n    transform: scale(1.05);\n  }\n  \n  &:active {\n    transform: scale(0.95);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(230);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("2144f390", content, true, {});

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/audioBtn.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB","file":"audioBtn.vue","sourcesContent":["\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioBtn_scss__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioBtn_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__audioBtn_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_audioService__ = __webpack_require__(76);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "audio-btn",
  props: {
    urlId: {
      type: String | Number,
      require: true
    },
    height: {
      type: Number,
      default: 50
    },
    autoplay: {
      type: Boolean,
      deafult: false
    },
    idx: {
      type: Number,
      default: 0
    },
    display: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      audioSrc: "",
      isStop: null,
      showError: false
    };
  },
  created: function created() {
    this.getAudio();
  },

  watch: {
    urlId: function urlId() {
      if (this.idx) return;
      this.isStop = true;
      this.getAudio();
    },
    idx: function idx() {
      this.isStop = true;
      this.getAudio();
    },
    autoplay: function autoplay() {
      if (this.autoplay) this.playAudio();
    }
  },
  methods: {
    getAudio: function getAudio() {
      var _this = this;

      console.log(this.autoplay);
      if (this.urlId) {
        __WEBPACK_IMPORTED_MODULE_3__services_audioService__["a" /* audioService */].playAudio(this.urlId).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
            var _ref2, sound_file;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return res.json();

                  case 2:
                    _ref2 = _context.sent;
                    sound_file = _ref2.sound_file;

                    _this.audioSrc = sound_file;
                    if (_this.autoplay && _this.audioSrc) {
                      // this.isStop = false;
                      _this.playAudio();
                    }

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.audioSrc = null;
      }
    },
    playAudio: function playAudio(ev) {
      var _this2 = this;

      if (ev) {
        ev.stopPropagation();
      }
      if (this.$store.getters.isPlaying) {
        setTimeout(function () {}, 1500);
      }
      var audio = new Audio(this.audioSrc);
      document.getElementById('speaker-svg').classList.add("is-playing");
      this.$store.commit("setIsPlaying", true);
      audio.play().then(this.$store.commit("setIsPlaying", false)).catch(function (e) {
        console.log(e);
        _this2.$store.commit("setError", e);
        _this2.$store.commit("setIsPlaying", false);
      });
      document.getElementById('speaker-svg').classList.remove("is-playing");
    }
  },
  updated: function updated() {
    console.log("audio is updated");
  },
  destroyed: function destroyed() {
    this.isStop = true;
  },

  components: {}
});

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(233);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("5ddadbf4", content, true, {});

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".audio-btn{cursor:pointer;position:relative}.audio .audio-btn{width:28px !important;aspect-ratio:1/1}.audio .audio-btn svg{width:100%;height:100%}.speaker-svg{width:60px;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.is-playing{box-shadow:0 0 10px 6px var(--bubble-bg-selected);border-radius:50%}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/audioBtn.scss","/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAGA,WACE,eACA,iBAAA,CAGF,kBACE,sBACA,gBAAA,CAGF,sBACE,WACA,WAAA,CAGF,aACE,WClBA,kBACA,QACA,SACA,+BAAA,CDmBF,YACE,kDACA,iBAAA,CAAA","file":"audioBtn.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n@import \"../../scss/abstracts/mixins\";\n\n.audio-btn {\n  cursor: pointer;\n  position: relative;\n}\n\n.audio .audio-btn {\n  width: 28px !important;\n  aspect-ratio: 1/1;\n}\n\n.audio .audio-btn svg {\n  width: 100%;\n  height: 100%;\n}\n\n.speaker-svg {\n  width: 60px;\n  @include absCenter;\n\n}\n.is-playing {\n  box-shadow: 0 0 10px 6px var(--bubble-bg-selected);\n  border-radius: 50%;\n}","@mixin absCenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n//media query\n//1em=16px\n// em and rem in media query always equall fs from browser =16px unless user change it.\n//rem failed work with some of browrswers\n@mixin respon($breakpoint) {\n  @if $breakpoint==no-phone {\n    @media (min-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==phone {\n    @media (max-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==700px {\n    @media (max-width: 43.75em) {\n      //700px\n      @content;\n    }\n  }\n  @if $breakpoint==tab-port {\n    @media (max-width: 56.25em) {\n      //900px\n      @content;\n    }\n  }\n\n  @if $breakpoint==tab-land {\n    @media (max-width: 75em) {\n      //1200px\n      @content;\n    }\n  }\n  @if $breakpoint==big-desktop {\n    //1800px\n    @media (min-width: 112.5em) {\n      @content;\n    }\n  }\n}\n\n@mixin aspect-ratio($width, $height) {\n  position: relative;\n  overflow: hidden;\n  &:before {\n    display: block;\n    content: \"\";\n    width: 100%;\n    padding-top: ($height / $width) * 100%;\n  }\n  > * {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  }\n\n  > img {\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.audioSrc) ? _c('button', {
    staticClass: "audio-btn",
    style: ({
      height: _vm.height + 'px',
      width: _vm.height + 'px',
      display: _vm.display ? 'inline-block' : 'none'
    }),
    on: {
      "click": _vm.playAudio
    }
  }, [_c('audio', [_c('source', {
    attrs: {
      "src": _vm.audioSrc,
      "type": "audio/mp3"
    }
  })]), _vm._v(" "), _c('inline-svg', {
    staticClass: "speaker-svg",
    attrs: {
      "id": "speaker-svg",
      "src": __webpack_require__(208).default,
      "aria-label": "My image"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.audioSrc) ? _c('div', {
    staticClass: "noaudio"
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    height: { type: String, required: true }
  }
});

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: (_vm.height + "px")
    })
  })
},staticRenderFns: []}

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_audioService__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_settingsService__ = __webpack_require__(209);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AudioPlayer",
  data: function data() {
    return {
      audioFile: null,
      audio: null,
      progressBar: 0,
      isPlaying: null,
      soundSetting: null,
      speakSetting: null,
      playbackRate: 1,
      availableSpeeds: [1, 1.25, 1.5, 2]
    };
  },

  props: {
    urlId: {
      type: String | Number,
      require: false
    },
    hideProgressBar: {
      type: Boolean,
      default: false
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    audioSrc: { type: String, required: true }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__services_settingsService__["a" /* settingsService */].getSettings();

            case 2:
              _this.soundSetting = _context.sent;

              _this.loadSavedSpeed();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    console.log(this.hideProgressBar);
    if (this.urlId) {
      this.getAudio();
    } else {
      this.audioFile = this.audioSrc;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.audio.pause();
  },

  watch: {
    urlId: function urlId() {
      // this.isStop = true;
      this.getAudio();
    },
    audioFile: function audioFile() {
      this.makeAudio(this.audioFile);
    },
    soundSetting: function soundSetting() {
      if (this.soundSetting && this.soundSetting.length) {
        this.speakSetting = this.soundSetting[1];
      }
      if (this.audio && this.autoPlay && this.speakSetting) this.play();
    },
    audio: function audio() {
      console.log(this.speakSetting);
      if (this.autoPlay && this.speakSetting) this.play();
    },
    progressBar: function progressBar() {
      this.$refs.progressBar.style.backgroundSize = (this.progressBar - 0) * 100 / (100 - 0) + "% 100%";
    },
    $route: function $route(to, from) {
      this.audio.pause();
    }
  },
  methods: {
    getAudio: function getAudio() {
      var _this2 = this;

      if (this.urlId) {
        __WEBPACK_IMPORTED_MODULE_3__services_audioService__["a" /* audioService */].playAudio(this.urlId).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
            var _ref2, mediaUrl;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return res.json();

                  case 2:
                    _ref2 = _context2.sent;
                    mediaUrl = _ref2.mediaUrl;

                    _this2.audioFile = mediaUrl;

                    //this.makeAudio(this.audioFile);
                    // if (this.autoplay) {
                    //   this.isStop = false;
                    //   this.playAudio();
                    // }

                  case 5:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.audioFile = null;
      }
    },
    changeProgress: function changeProgress(e) {
      if (this.audio) this.audio.currentTime = this.audio.duration / 100 * e.target.value;
      var el = e.target;
      console.log((el.value - 0) * 100 / (100 - 0) + "% 100%");
      el.style.backgroundSize = (el.value - 0) * 100 / (100 - 0) + "% 100%";
    },
    play: function play(e) {
      console.log(this.audio.paused);
      if (e) e.stopPropagation();
      if (!this.audio.paused) {
        this.audio.pause();
      } else {
        this.audio.play();
      }
    },
    pause: function pause() {
      this.audio.pause();
    },
    makeAudio: function makeAudio(audioFile) {
      var _this3 = this;

      this.audio = new Audio(audioFile);

      this.audio.volume = 0.5;
      this.audio.playbackRate = this.playbackRate;
      this.audio.addEventListener("timeupdate", function (e) {
        _this3.progressBar = _this3.audio.currentTime / _this3.audio.duration * 100;
      });

      this.audio.addEventListener("ended", function () {
        _this3.audio.currentTime = 0;
        _this3.audio.pause();
      });
    },
    cycleSpeed: function cycleSpeed() {
      var currentIndex = this.availableSpeeds.indexOf(this.playbackRate);
      var nextIndex = (currentIndex + 1) % this.availableSpeeds.length;
      this.playbackRate = this.availableSpeeds[nextIndex];

      if (this.audio) {
        this.audio.playbackRate = this.playbackRate;
      }

      // שמירת המהירות ב-localStorage
      localStorage.setItem('audioPlaybackRate', this.playbackRate);
    },
    loadSavedSpeed: function loadSavedSpeed() {
      var savedRate = localStorage.getItem('audioPlaybackRate');
      if (savedRate && this.availableSpeeds.includes(parseFloat(savedRate))) {
        this.playbackRate = parseFloat(savedRate);
      }
    }
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "audio-player-container"
  }, [_c('img', {
    class: {
      disabledBtn: !_vm.audioFile
    },
    attrs: {
      "width": _vm.hideProgressBar ? '50px' : '25px',
      "height": _vm.hideProgressBar ? '50px' : '25px',
      "src": _vm.audio && _vm.audio.paused ?
        __webpack_require__(208).default :
        __webpack_require__(240).default
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), (!_vm.hideProgressBar && _vm.audioFile) ? _c('button', {
    staticClass: "speed-btn",
    attrs: {
      "title": ("מהירות: " + _vm.playbackRate + "x")
    },
    on: {
      "click": _vm.cycleSpeed
    }
  }, [_vm._v("\n    " + _vm._s(_vm.playbackRate) + "x\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.hideProgressBar) ? _c('input', {
    ref: "progressBar",
    staticClass: "slider",
    attrs: {
      "type": "range",
      "name": "progressBar",
      "id": "progressBar"
    },
    domProps: {
      "value": _vm.progressBar
    },
    on: {
      "input": _vm.changeProgress
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAxNyAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43MDg5ODQiIHdpZHRoPSI1Ljc3MTgxIiBoZWlnaHQ9IjI1IiByeD0iMi44ODU5MSIgZmlsbD0iIzU1NTVGRiIvPgo8cmVjdCB4PSIxMC4zMjkxIiB3aWR0aD0iNS43NzE4MSIgaGVpZ2h0PSIyNSIgcng9IjIuODg1OTEiIGZpbGw9IiM1NTU1RkYiLz4KPC9zdmc+Cg==");

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(244);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("0c4970e0", content, true, {});

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"progressBar.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progressBar_scss__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progressBar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progressBar_scss__);

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "progress-bar",
  props: {
    max: {
      type: Number,
      default: 100
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      style: {}
    };
  },
  created: function created() {
    this.style = { width: this.progress / this.max * 100 + "%" };
  },

  computed: {},
  watch: {
    progress: function progress() {
      this.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.style, {
        width: this.progress / this.max * 100 + "%"
      });
    }
  },
  methods: {}
});

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(247);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("351700dc", content, true, {});

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".progress-bar{border:#000 1px solid;font-size:40px;height:40px}.progress-bar .container{background-color:#41d988;text-align:center;height:100%;align-items:center}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/progressBar.scss"],"names":[],"mappings":"AACA,cACE,sBACA,eACA,WAAA,CACA,yBACE,yBACA,kBACA,YACA,kBAAA,CAAA","file":"progressBar.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n.progress-bar {\n  border: black 1px solid;\n  font-size: 40px;\n  height: 40px;\n  .container {\n    background-color: $green;\n    text-align: center;\n    height: 100%;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "container flex",
    style: (_vm.style)
  }, [_c('span', {
    staticClass: "mr-20"
  }, [_vm._v(" " + _vm._s(Math.round((_vm.progress / _vm.max) * 100)) + "%")])])])
},staticRenderFns: []}

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(261),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19b20649",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOSS1.5b5a277.mp3";

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(257);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("86881e7a", content, true, {});

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.modal[data-v-19b20649] {\n  padding: 0;\n  padding-top: 15px;\n  position: absolute;\n}\n.video-p[data-v-19b20649] {\n  width: 100%;\n  height: 250px;\n}\n.approve[data-v-19b20649] {\n  background: var(--button-primary);\n  color: var(--button-primary-text);\n  padding: 4px;\n  border-radius: 8px;\n  min-height: 60px;\n  width: 100%;\n  font: var(--medium-font);\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/onBoardingModal/OnBoardingModal.vue"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,cAAc;CACf;AACD;EACE,kCAAkC;EAClC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;CAC1B","file":"OnBoardingModal.vue","sourcesContent":["\n.modal[data-v-19b20649] {\n  padding: 0;\n  padding-top: 15px;\n  position: absolute;\n}\n.video-p[data-v-19b20649] {\n  width: 100%;\n  height: 250px;\n}\n.approve[data-v-19b20649] {\n  background: var(--button-primary);\n  color: var(--button-primary-text);\n  padding: 4px;\n  border-radius: 8px;\n  min-height: 60px;\n  width: 100%;\n  font: var(--medium-font);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_courseService__ = __webpack_require__(77);



var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      closed: false,
      isAudio: 1,
      lessonImage: null
    };
  },

  props: {
    text: {
      type: String,
      default: ""
    },
    audioSrc: {
      type: String,
      default: ""
    },
    vidSrc: {
      type: String,
      default: ""
    },
    imgSrc: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "lesson"
    },
    id: {
      type: Number,
      default: 0
    }
  },
  watch: {
    audioSrc: function audioSrc() {
      if (this.audioSrc) this.isAudio = 0;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var lesson;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.lessonImage = _this.imgSrc;
              lesson = void 0;

              if (!(_this.type === "lesson")) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7__services_courseService__["a" /* courseService */].getLessonFromServer(_this.id);

            case 5:
              lesson = _context.sent;

              if (lesson.game) _this.lessonImage = lesson.game.intro_image;

            case 7:
              if (!(_this.type === "game")) {
                _context.next = 13;
                break;
              }

              _context.next = 10;
              return __WEBPACK_IMPORTED_MODULE_7__services_courseService__["a" /* courseService */].getGame(_this.id);

            case 10:
              lesson = _context.sent;

              console.log(lesson);
              _this.lessonImage = lesson.intro_image;

            case 13:
              if (_this.audioSrc) _this.isAudio = 0;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    closePop: function closePop(e) {
      this.closed = true;
      this.$emit("clicked", this.id);
    },

    makeLinkEmbaddable: function makeLinkEmbaddable(link) {
      if (String(link).includes("shorts")) {
        var _youtubeID = String(link).split("/shorts/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      if (String(link).includes(".be/")) {
        var _youtubeID2 = String(link).split(".be/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID2 + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      var youtubeID = String(link).split("watch?v=")[1];
      return "https://www.youtube.com/embed/" + youtubeID + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0";
    }
  },

  components: { AudioPlayer: __WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue___default.a, VideoPlayer: __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue___default.a, AudioBtn1: __WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue___default.a, VideoPlayer1: __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue___default.a, Spacer: __WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue___default.a }
});

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(260);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("4754144f", content, true, {});

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".blackBG{background-color:var(--color-primary);opacity:.4;position:fixed;top:0;left:0;width:100%;height:100%;z-index:10}.modal{display:flex;flex-direction:column;align-items:center;text-align:center;z-index:1001;background-color:var(--bg-primary);opacity:1;padding:32px 18px !important;border-radius:4px;max-width:calc(100vw - 36px);top:80px;left:50%;margin-top:16px;transform:translate(-50%, 0);justify-content:space-between;gap:24px;max-height:75vh;overflow-y:auto}#img{width:100%;height:auto}.hide{display:none}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/onBoardingModal/src/components/onBoardingModal/style.scss"],"names":[],"mappings":"AAAA,SACE,sCACA,WACA,eACA,MACA,OACA,WACA,YACA,UAAA,CAGF,OACE,aACA,sBACA,mBACA,kBACA,aACA,mCACA,UACA,6BACA,kBACA,6BACA,SACA,SACA,gBACA,6BACA,8BACA,SACA,gBACA,eAAA,CAGF,KACE,WACA,WAAA,CAGF,MACE,YAAA,CAAA","file":"style.scss","sourcesContent":[".blackBG {\n  background-color: var(--color-primary);\n  opacity: 0.4;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n\n.modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  z-index: 1001;\n  background-color: var(--bg-primary);\n  opacity: 1;\n  padding: 32px 18px !important;\n  border-radius: 4px;\n  max-width: calc(100vw - 36px);\n  top: 80px;\n  left: 50%;\n  margin-top: 16px;\n  transform: translate(-50%, 0);\n  justify-content: space-between;\n  gap: 24px;\n  max-height: 75vh;\n  overflow-y: auto;\n}\n\n#img {\n  width: 100%;\n  height: auto;\n}\n\n.hide {\n  display: none;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.closed) ? _c('div', [_c('div', {
    staticClass: "blackBG"
  }), _vm._v(" "), _c('div', {
    staticClass: "onboarding"
  }, [_c('div', {
    staticClass: "modal"
  }, [(_vm.audioSrc) ? _c('AudioPlayer', {
    attrs: {
      "audioSrc": _vm.audioSrc,
      "autoPlay": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('VideoPlayer1', {
    staticClass: "video-p",
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.vidSrc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('img', {
    attrs: {
      "id": "img",
      "src": _vm.lessonImage
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "approve",
    on: {
      "click": _vm.closePop
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("OnBoardingModal.OnBoardingModal.start")) + "\n      ")])], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOSS2.34d9197.mp3";

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY-FULL.3c0441a.mp3";

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./VICTORY-FULL.mp3": 292,
	"./VICTORY1.mp3": 301,
	"./VICTORY2.mp3": 302,
	"./VICTORY3.mp3": 303,
	"./VICTORY4.mp3": 304,
	"./VICTORY5.mp3": 305,
	"./VICTORY6.mp3": 306,
	"./VICTORY7.mp3": 307,
	"./VICTORY8.mp3": 308
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY1.c764be9.mp3";

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY2.d309bef.mp3";

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY3.353f6b2.mp3";

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY4.718dc3e.mp3";

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY5.ef5b443.mp3";

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY6.679e925.mp3";

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY7.651c4a6.mp3";

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY8.32860f5.mp3";

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(388);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("d3b5f82e", content, true, {});

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.loader[data-v-37c53c7c] {\n  text-align: center;\n  margin: 30px;\n}\nbutton[data-v-37c53c7c] {\n  border: none;\n}\n.theword[data-v-37c53c7c] {\n  position: absolute;\n  z-index: -1;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Game-new/game-page.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,YAAY;CACb","file":"game-page.vue","sourcesContent":["\n.loader[data-v-37c53c7c] {\n  text-align: center;\n  margin: 30px;\n}\nbutton[data-v-37c53c7c] {\n  border: none;\n}\n.theword[data-v-37c53c7c] {\n  position: absolute;\n  z-index: -1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__game_page_scss__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__game_page_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__game_page_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__game_summary_vue__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__game_summary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__game_summary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__game_header_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__game_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__game_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_progressBar_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_progressBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Shared_progressBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__onBoardingModal_OnBoardingModal_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__onBoardingModal_OnBoardingModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__onBoardingModal_OnBoardingModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_audioBtn_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_audioBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Shared_audioBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_wordService__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_userService__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_settingsService__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_Slinky_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_Slinky_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Shared_Slinky_vue__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import confetti from "canvas-confetti";



var initializeState = {
  currItems: [],
  chapter: null,
  questions: [],
  question: null,
  WIN: 3,
  LOSS: 0,
  idx: 0,
  showNext: false,
  isClicked: false,
  status: "",
  choosenId: "",
  isSummary: false,
  showResults: false,
  results: [],
  onlyArbT: false,
  msg: "",
  savedWords: [],
  courseData: null,
  currentWord: null,
  trigger: 1,
  autoPlay: true,
  soundsPlay: true,
  soundSetting: [],
  error: false,
  title: null,
  itemsLength: 0,
  AllItems: 0,
  skip: true,
  progress: 0
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "game-new",
  props: ["data", "type"],
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, initializeState);
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(["words", "chapters", "user"]), {
    currentGame: function currentGame() {
      return this.$store.getters.currentGame;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("Game data: ", _this.currentGame);
              _this.init();
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_14__services_settingsService__["a" /* settingsService */].getSettings();

            case 4:
              _this.soundSetting = _context.sent;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    $route: function $route(to, from) {
      this.init();
    },
    currentGame: function currentGame() {
      this.courseData = this.currentGame;
    },
    question: function question() {
      this.currentWord = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.question));
      this.currentWord.qWord.know = this.currentWord.qWord.know ? this.currentWord.qWord.know : 0;
    },
    currentWord: function currentWord() {
      console.log("CURRENT WORD MAIN CHNAGE");
    },
    user: function user() {
      if (!this.showResults && !this.isSummary) {
        this.init();
      }
    },
    soundSetting: function soundSetting() {
      if (this.soundSetting && this.soundSetting.length) this.autoPlay = this.soundSetting[1];
      this.soundsPlay = this.soundSetting[0];
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _$route$params, id, gameid, gameWords, _gameWords, _gameWords2, gameRandomWords, groupId, _gameWords3, _gameRandomWords, _gameWords4, _gameRandomWords2, _gameWords5, _gameRandomWords3, _gameWords6, _gameRandomWords4, items;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.currItems = [], _this2.chapter = null, _this2.questions = [], _this2.idx = 0, _this2.LOSS = 0, _this2.showNext = false, _this2.isClicked = false, _this2.status = "", _this2.choosenId = "", _this2.isSummary = false, _this2.showResults = false, _this2.results = [];
                _this2.savedWords = [];
                _$route$params = _this2.$route.params, id = _$route$params.id, gameid = _$route$params.gameid;

                // console.log("INIT HERE", gameid);
                // console.log(this.$route.query);
                // Game with half score

                if (!(_this2.type === "half")) {
                  _context2.next = 16;
                  break;
                }

                if (!_this2.data) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getGameWords(_this2.data.game.algolia_game_id);

              case 7:
                gameWords = _context2.sent;

                _this2.WIN = 2;
                console.log(gameWords);
                if (!gameWords) {
                  _this2.error = true;
                }
                console.log(_this2.words);
                //console.log(this.words.filter(w => w.id === "1774"));
                // this.currItems = await this.words.filter(w =>
                //   gameWords.includes(parseInt(w.id))
                // );
                _this2.currItems = gameWords;
                // if (gameWords.length == 0) this.$router.push("/chapter");
                if (_this2.user) {
                  _this2.currItems.forEach(function (word) {
                    var kW = _this2.user.known_words.find(function (w) {
                      return w.external_id == word.id;
                    });
                    if (kW) {
                      word.know = kW.score || 0;
                    }
                  });
                }
                //this.currItems.forEach(item => (item.know = 1));
                console.log(_this2.currItems);

              case 15:
                _this2.chapter = {
                  title: _this2.$t("game-new.game-page.game"),
                  questionsNumber: 10
                };

              case 16:
                if (!(_this2.type === "full")) {
                  _context2.next = 25;
                  break;
                }

                if (!_this2.data) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 20;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getGameWords(_this2.data.game.algolia_game_id);

              case 20:
                _gameWords = _context2.sent;

                _this2.WIN = 4;
                // this.currItems = await this.words.filter(w =>
                //   gameWords.includes(parseInt(w.id))
                // );
                _this2.currItems = _gameWords;
                if (_this2.user) {
                  _this2.currItems.forEach(function (word) {
                    var kW = _this2.user.known_words.find(function (w) {
                      return w.external_id == word.id;
                    });
                    if (kW) {
                      console.log(kW);
                      word.know = kW.score || 0;
                    }
                  });
                }

              case 24:
                _this2.chapter = {
                  title: _this2.$t("game-new.game-page.game"),
                  questionsNumber: 10
                };

              case 25:
                if (!(gameid === "dicword")) {
                  _context2.next = 34;
                  break;
                }

                _gameWords2 = [_this2.$route.query];
                gameRandomWords = [];
                _context2.next = 30;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getRandomWords(7);

              case 30:
                gameRandomWords = _context2.sent;

                _this2.WIN = 4;
                _this2.currItems = _gameWords2.concat(gameRandomWords);
                _this2.chapter = {
                  title: _this2.$t("game-new.game-page.game"),
                  questionsNumber: 10
                };

              case 34:
                if (!(gameid === "group")) {
                  _context2.next = 50;
                  break;
                }

                groupId = _this2.$route.query.id;
                _gameWords3 = void 0;

                if (!groupId) {
                  _context2.next = 41;
                  break;
                }

                _context2.next = 40;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getGroupWords(groupId);

              case 40:
                _gameWords3 = _context2.sent;

              case 41:
                _gameRandomWords = [];

                if (!(_gameWords3.length < 4)) {
                  _context2.next = 46;
                  break;
                }

                _context2.next = 45;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getRandomWords(5);

              case 45:
                _gameRandomWords = _context2.sent;

              case 46:

                _this2.WIN = 4;
                _this2.currItems = _gameWords3.concat(_gameRandomWords);
                _this2.title = _this2.$route.query.name;
                _this2.chapter = {
                  title: _this2.$t("game-new.game-page.game"),
                  questionsNumber: 10
                };

              case 50:
                if (!(gameid === "savedwords")) {
                  _context2.next = 65;
                  break;
                }

                // if (!this.user.saved_words.length) {
                //   console.log("NO SAVED WORDS...");
                // }
                if (!_this2.user.saved_words.length) {
                  console.log("NO SAVED WORDS");
                  _this2.$router.push("/chapter/saved-words");
                }

                if (!(_this2.user && _this2.user.saved_words.length)) {
                  _context2.next = 63;
                  break;
                }

                _context2.next = 55;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getSavedWords(_this2.user);

              case 55:
                _gameWords4 = _context2.sent;
                _gameRandomWords2 = [];

                if (!(_this2.user.saved_words.length < 4)) {
                  _context2.next = 61;
                  break;
                }

                _context2.next = 60;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getRandomWords(5);

              case 60:
                _gameRandomWords2 = _context2.sent;

              case 61:
                _this2.WIN = 4;
                // this.currItems = await this.words.filter(w =>
                //   gameWords.includes(parseInt(w.id))
                // );
                _this2.currItems = _gameWords4.concat(_gameRandomWords2);

              case 63:
                _this2.title = _this2.$t("game-new.game-page.saved");
                _this2.chapter = {
                  title: _this2.$t("game-new.game-page.game"),
                  questionsNumber: 10
                };

              case 65:
                if (!(gameid === "processwords")) {
                  _context2.next = 81;
                  break;
                }

                if (!_this2.user.known_words.length) {
                  console.log("NO KNOWN WORDS");
                  _this2.$router.push("/chapter/saved-words");
                }

                if (!(_this2.user && _this2.user.known_words.length)) {
                  _context2.next = 79;
                  break;
                }

                _context2.next = 70;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getKnownWords(_this2.user);

              case 70:
                _gameWords5 = _context2.sent;

                _gameWords5 = _gameWords5.filter(function (res) {
                  return res.know > 0 && res.know < 4;
                });
                _gameRandomWords3 = [];

                if (!(_gameWords5.length < 4)) {
                  _context2.next = 77;
                  break;
                }

                _context2.next = 76;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getRandomWords(5);

              case 76:
                _gameRandomWords3 = _context2.sent;

              case 77:
                _this2.WIN = 4;

                _this2.currItems = _gameWords5.concat(_gameRandomWords3);

              case 79:
                _this2.title = _this2.$t("game-new.game-page.process");
                _this2.chapter = {
                  title: _this2.$t("game-new.game-page.game"),
                  questionsNumber: 10
                };

              case 81:
                if (!(gameid === "fullwords")) {
                  _context2.next = 97;
                  break;
                }

                if (!_this2.user.known_words.length) {
                  console.log("NO KNOWN WORDS");
                  _this2.$router.push("/chapter/saved-words");
                }

                if (!(_this2.user && _this2.user.known_words.length)) {
                  _context2.next = 95;
                  break;
                }

                _context2.next = 86;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getKnownWords(_this2.user);

              case 86:
                _gameWords6 = _context2.sent;

                _gameWords6 = _gameWords6.filter(function (res) {
                  return res.know === 4;
                });
                _gameRandomWords4 = [];

                if (!(_gameWords6.length < 4)) {
                  _context2.next = 93;
                  break;
                }

                _context2.next = 92;
                return __WEBPACK_IMPORTED_MODULE_12__services_wordService__["a" /* wordService */].getRandomWords(5);

              case 92:
                _gameRandomWords4 = _context2.sent;

              case 93:
                _this2.WIN = 4;

                _this2.currItems = _gameWords6.concat(_gameRandomWords4);

              case 95:
                _this2.title = _this2.$t("game-new.game-page.full");
                _this2.chapter = {
                  title: _this2.$t("game-new.game-page.game"),
                  questionsNumber: 10
                };

              case 97:
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.currItems).length) {
                  console.log("GOTO", _this2.currItems);
                  console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.currItems).length);
                  items = _this2.currItems.filter(function (item) {
                    return item.know < _this2.WIN || !item.know;
                  });

                  if (!items.length && !_this2.showResults) {
                    console.log("DOING THIS SHIT HERE");
                    _this2.currItems.forEach(function (item) {
                      return item.know = _this2.WIN - 1;
                    });
                  }
                  _this2.itemsLength = items.length;
                  _this2.AllItems = items.length;
                  _this2.generateQuestion();
                } else {
                  // this.init();
                }

              case 98:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    capitalize: function capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    playWrongAudio: function playWrongAudio(ev) {
      if (!this.soundsPlay) return;
      var audio = new Audio(__webpack_require__(266));
      if (this.LOSS % 2 === 0) audio = new Audio(__webpack_require__(253));
      audio.play();
      this.LOSS = this.LOSS + 1;
    },
    playRightAudio: function playRightAudio(num) {
      if (!this.soundsPlay) return;
      var audio = new Audio(__webpack_require__(293)("./VICTORY" + num + ".mp3"));
      audio.play();
    },
    onBoardingClose: function onBoardingClose(value) {
      this.generateQuestion();
    },
    generateQuestion: function generateQuestion() {
      var _this3 = this;

      var lastWord = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var _$route$params2 = this.$route.params,
          type = _$route$params2.type,
          grammar = _$route$params2.grammar,
          id = _$route$params2.id;

      var questions = [];

      var items = id === "savedWords" ? this.savedWords : this.currItems;

      //this.currItems[0].know = 5;
      console.log("AAAAAA", items);
      items = items.filter(function (item) {
        return (item.know < _this3.WIN || !item.know) && item.objectID !== lastWord.objectID;
      });
      if (items.length < 1) {
        items = id === "savedWords" ? this.savedWords : this.currItems;
        items = items.filter(function (item) {
          return item.objectID !== lastWord.objectID;
        });
      }
      // console.log(items);
      // if (!items.length) {
      //   items = this.currItems;
      // }
      console.log("CCC", items);
      var question = {
        qWord: this.getRandomWord(items, true),
        answers: [],
        // onlyAudio: Math.random() > 0.5 ? true : false
        onlyAudio: false
      };

      var answers = this.generateAnswer("aaa", "type", question.qWord);
      //remove the used word from items array

      answers = this.randomList(answers);
      question.answers = answers;
      questions.push(question);

      console.log(questions);

      this.questions = questions;
      this.question = question;
      this.playedItems = questions.map(function (q) {
        return q.qWord;
      });
    },
    removeWord: function removeWord(word, items) {
      var newItems = [];
      for (var i = 0; i < items.length; i++) {
        if (items[i] != word) {
          newItems.push(items[i]);
        }
      }
      return newItems;
    },
    getRandomWord: function getRandomWord() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currItems;
      var isQuestion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 12;

      var randomNumber = Math.floor(Math.random() * items.length);

      var ranWord = items[randomNumber];
      if (ranWord) {
        if (ranWord.know >= 5 && isQuestion && limit > 0) {
          return this.getRandomWord(items, isQuestion, limit - 1);
        } else {
          return ranWord;
        }
      }
    },
    generateAnswer: function generateAnswer(family, kind, rightAnswer) {
      console.log(rightAnswer);
      var filteredWords = this.currItems.filter(function (i) {
        return i.id !== rightAnswer.id;
      });
      console.log(filteredWords);
      console.log(rightAnswer);
      var answers = [rightAnswer];
      var limit = 30;
      var max = filteredWords.length <= 3 ? filteredWords.length - 1 : 3;
      for (var i = 0; i < max; i++) {
        var randomAnswer = this.getRandomWord(filteredWords, false, limit);
        var ids = answers.map(function (a) {
          return a.objectID;
        });
        ids.includes(randomAnswer.objectID) && max < limit ? max++ : answers.push(randomAnswer);
      }
      console.log(answers);

      return answers;
    },
    checkAnswerA: function checkAnswerA(answer) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _$route$params3, id, type, grammar, newidx, _newidx, items, known_words;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _$route$params3 = _this4.$route.params, id = _$route$params3.id, type = _$route$params3.type, grammar = _$route$params3.grammar;

                if (!_this4.isClicked) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _this4.isClicked = true;
                _this4.choosenId = answer.objectID;
                if (answer.heb === _this4.question.qWord.heb) {
                  _this4.status = "right";
                  console.log("currentWord", _this4.currentWord);
                  if (_this4.currentWord.qWord.know < 4) _this4.currentWord.qWord.know = _this4.currentWord.qWord.know + 1;
                  _this4.currentWord = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this4.currentWord));
                  _this4.trigger++;

                  //this.playedItems[this.idx].isRight = true;
                  newidx = _this4.currItems.findIndex(function (element) {
                    return element.objectID === answer.objectID;
                  });

                  _this4.currItems[newidx].know = _this4.currItems[newidx].know ? _this4.currItems[newidx].know + 1 : 1;
                  if (_this4.currItems[newidx].know > 4) _this4.currItems[newidx].know = 4;
                  console.log("RIGHT!", _this4.currItems[newidx].know);
                  _this4.playRightAudio(_this4.currItems[newidx].know);
                } else {
                  _this4.status = "wrong";
                  _this4.playWrongAudio();
                  _this4.currentWord.qWord.know = _this4.currentWord.qWord.know ? _this4.currentWord.qWord.know - 1 : 0;
                  _this4.currentWord = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this4.currentWord));
                  //this.playedItems[this.idx].isRight = false;
                  _newidx = _this4.currItems.findIndex(function (element) {
                    return element.objectID === _this4.question.qWord.objectID;
                  });

                  _this4.currItems[_newidx].know = _this4.currItems[_newidx].know ? _this4.currItems[_newidx].know - 1 : 0;
                  _this4.currItems[_newidx].wrong = _this4.currItems[_newidx].wrong ? _this4.currItems[_newidx].wrong + 1 : 1;
                  console.log("WRONG!", _this4.currItems[_newidx].know);
                }
                items = _this4.currItems.filter(function (item) {
                  return item.know < _this4.WIN || !item.know;
                });

                _this4.itemsLength = items.length;
                console.log("ITEMS", items);

                if (!(items.length && _this4.skip)) {
                  _context3.next = 13;
                  break;
                }

                // if (this.status == "right") {
                //   setTimeout(() => this.nextQuestion(), 500);
                // }
                _this4.showNext = true;
                _context3.next = 22;
                break;

              case 13:
                // confetti({
                //   particleCount: 50,
                //   spread: 70,
                //   origin: { y: 0.6 },
                //   ticks: 200
                // });
                _this4.showResults = true;
                known_words = _this4.currItems.map(function (word) {
                  return { external_id: word.id, score: word.know };
                }).filter(function (res) {
                  return res.external_id;
                });

                console.log(known_words);

                if (!_this4.data) {
                  _context3.next = 19;
                  break;
                }

                _context3.next = 19;
                return __WEBPACK_IMPORTED_MODULE_13__services_userService__["a" /* userService */].finishLesson(_this4.data.id, _this4.user);

              case 19:
                if (!_this4.user) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 22;
                return __WEBPACK_IMPORTED_MODULE_13__services_userService__["a" /* userService */].updateWords(known_words);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    nextQuestion: function nextQuestion() {
      this.choosenId = null;
      this.isClicked = false;
      this.idx++;
      this.showNext = false;
      // this.question.qWord.id = null;
      console.log("BBBB", this.question.qWord);
      this.generateQuestion(this.question.qWord);
    },
    randomList: function randomList(answers) {
      return answers.sort(function () {
        return 0.5 - Math.random();
      });
    },
    goBack: function goBack() {
      this.$router.push("/chapter");
    },
    showSummary: function showSummary() {
      var _this5 = this;

      var _$route$params4 = this.$route.params,
          id = _$route$params4.id,
          type = _$route$params4.type,
          grammar = _$route$params4.grammar;

      this.progress = 0;
      var items = this.playedItems;
      items.forEach(function (item) {
        if (item.isRight) {
          _this5.progress += 1;
        }
      });
      this.progress = this.progress / this.playedItems.length * 100;
      var rightItems = this.playedItems.filter(function (i) {
        return i.isRight;
      });
      this.isSummary = true, this.showResults = false;
      this.msg = this.$t("game-new.game-page.welldone");
      if (!this.user) return;
    },
    restartGame: function restartGame() {
      this.init();
    }
  },
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_9__Shared_progressBar_vue___default.a,
    AudioBtn: __WEBPACK_IMPORTED_MODULE_11__Shared_audioBtn_vue___default.a,
    GameSummary: __WEBPACK_IMPORTED_MODULE_7__game_summary_vue___default.a,
    GameHeader: __WEBPACK_IMPORTED_MODULE_8__game_header_vue___default.a,
    OnBoardingModal: __WEBPACK_IMPORTED_MODULE_10__onBoardingModal_OnBoardingModal_vue___default.a,
    SlinkyVue: __WEBPACK_IMPORTED_MODULE_15__Shared_Slinky_vue___default.a
  }
});

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(391);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("296e089c", content, true, {});

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".game-page{height:100svh;display:flex;flex-direction:column;justify-content:space-between}.game-page .game-header .title{text-align:center;color:var(--game-button-stroke);background-color:var(--bubble-primary);border:1px solid var(--game-button-stroke);font-weight:700}.game-page .word-game-main{margin-top:24px;font:var(--large-font);display:flex;flex-direction:column;justify-content:end}.game-page .word-game-main .question{display:flex;flex-direction:column;align-items:center;justify-content:space-around;height:20vh}.game-page .word-game-main .question .q{font:var(--large-font);text-align:center;direction:var(--dest-direction)}.game-page .word-game-main .answers{-webkit-user-select:none;-ms-user-select:none;user-select:none;align-content:end;display:flex;flex-direction:column;margin:0 auto;margin-top:10vh;grid-template-columns:repeat(1, 1fr);gap:8px;width:70%;padding:0}.game-page .word-game-main .answers li{transition:box-shadow .2s ease-in-out;border:2px solid var(--game-button-stroke);padding:8px;border-radius:50px;color:var(--header-primary);text-align:center;cursor:pointer}@media(min-width: 37.5em){.game-page .word-game-main .answers li:hover{color:var(--button-primary-text);background-color:var(--button-primary)}}.game-page .word-game-main .answers li:active{transform:scale(0.98)}.game-page .actions-wrapper{height:100px;margin-top:10vh;width:100%}.game-page .btn-next,.game-page .btn-restart,.game-page .btn-results,.game-page .btnSum{width:100%;height:100%;text-align:center;justify-content:center;font:var(--huge-font);display:flex;padding:8px;color:var(--button-primary-text);background-color:var(--button-primary)}.game-page .btn-next:hover,.game-page .btn-restart:hover,.game-page .btn-results:hover,.game-page .btnSum:hover{color:var(--button-primary-text);background-color:var(--bubble-bg-selected)}.game-page .nope{transition:background-color 2s ease-in;transition:border-color 2s ease-in;background-color:var(--bg-primary);box-shadow:none !important;border-color:var(--bubble-primary) !important;color:var(--color-disabled) !important}.game-page .wrong{background-color:var(--error-primary);border-color:var(--error-primary) !important;color:var(--bg-primary) !important}.game-page .damnright{transition:background-color 2s ease-in;transition:border-color 2s ease-in;box-shadow:none !important;border-color:var(--success-stroke) !important;background-color:var(--success-primary);color:var(--success-secondary) !important}.game-page .damnright:hover{color:var(--bg-primary) !important;background-color:var(--bubble-bg-selected)}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Game-new/src/components/Game-new/game-page.scss","/__w/lang_app_eng/lang_app_eng/src/components/Game-new/src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAGA,WACE,cACA,aACA,sBACA,6BAAA,CAGE,+BACE,kBACA,gCACA,uCACA,2CACA,eAAA,CAIJ,2BACE,gBACA,uBACA,aACA,sBACA,mBAAA,CAEA,qCACE,aACA,sBACA,mBACA,6BACA,WAAA,CAEA,wCACE,uBACA,kBACA,+BAAA,CAIJ,oCACE,yBACA,qBACA,iBACA,kBACA,aACA,sBACA,cACA,gBACA,qCACA,QACA,UACA,SAAA,CAEA,uCACE,sCACA,2CACA,YACA,mBACA,4BACA,kBAEA,cAAA,CCjDJ,0BDmDI,6CAEI,iCACA,sCAAA,CAAA,CAIJ,8CACE,qBAAA,CAMR,4BACE,aACA,gBACA,UAAA,CAGF,wFAIE,WACA,YACA,kBACA,uBACA,sBACA,aACA,YACA,iCACA,sCAAA,CAEA,gHACE,iCACA,0CAAA,CAGJ,iBACE,uCACA,mCACA,mCACA,2BACA,8CACA,sCAAA,CAIF,kBACE,sCACA,6CACA,kCAAA,CAGF,sBACE,uCACA,mCACA,2BAEA,8CACA,wCACA,yCAAA,CAEA,4BACE,mCACA,0CAAA,CAAA","file":"game-page.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n@import \"../../scss/abstracts/mixins\";\n\n.game-page {\n  height: 100svh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .game-header {\n    .title {\n      text-align: center;\n      color: var(--game-button-stroke);\n      background-color: var(--bubble-primary);\n      border: 1px solid var(--game-button-stroke);\n      font-weight: 700;\n    }\n  }\n\n  .word-game-main {\n    margin-top: 24px;\n    font:  var(--large-font);\n    display: flex;\n    flex-direction: column;\n    justify-content: end;\n\n    .question {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: space-around;\n      height: 20vh;\n\n      .q {\n        font: var(--large-font);\n        text-align: center;\n        direction: var(--dest-direction);\n      }\n    }\n\n    .answers {\n      -webkit-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n      align-content: end;\n      display: flex;\n      flex-direction: column;\n      margin: 0 auto;\n      margin-top: 10vh;\n      grid-template-columns: repeat(1, 1fr);\n      gap: 8px;\n      width: 70%;\n      padding: 0;\n\n      li {\n        transition: box-shadow 0.2s ease-in-out;\n        border: 2px solid var(--game-button-stroke);\n        padding: 8px;\n        border-radius: 50px;\n        color: var(--header-primary);\n        text-align: center;\n\n        cursor: pointer;\n\n        &:hover {\n          @include respon(no-phone) {\n            color: var(--button-primary-text);\n            background-color: var(--button-primary);\n          }\n        }\n\n        &:active {\n          transform: scale(0.98);\n        }\n      }\n    }\n  }\n\n  .actions-wrapper {\n    height: 100px;\n    margin-top: 10vh;\n    width: 100%;\n  }\n\n  .btn-next,\n  .btn-restart,\n  .btn-results,\n  .btnSum {\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    justify-content: center;\n    font: var(--huge-font);\n    display: flex;\n    padding: 8px;\n    color: var(--button-primary-text);\n    background-color: var(--button-primary);\n\n    &:hover {\n      color: var(--button-primary-text);\n      background-color: var(--bubble-bg-selected);\n    }\n  }\n  .nope {\n    transition: background-color 2s ease-in;\n    transition: border-color 2s ease-in;\n    background-color: var(--bg-primary);\n    box-shadow: none !important;\n    border-color: var(--bubble-primary) !important;\n    color: var(--color-disabled) !important;\n    // border-color: gray !important;\n  }\n  \n  .wrong {\n    background-color: var(--error-primary);\n    border-color: var(--error-primary) !important;\n    color: var(--bg-primary) !important;\n  }\n  \n  .damnright {\n    transition: background-color 2s ease-in;\n    transition: border-color 2s ease-in;\n    box-shadow: none !important;\n    // border-width: 0px !important;\n    border-color: var(--success-stroke) !important;\n    background-color: var(--success-primary);\n    color: var(--success-secondary) !important;\n\n    &:hover {\n      color: var(--bg-primary) !important;\n      background-color: var(--bubble-bg-selected);\n    }\n\n  }\n}\n\n","@mixin absCenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n//media query\n//1em=16px\n// em and rem in media query always equall fs from browser =16px unless user change it.\n//rem failed work with some of browrswers\n@mixin respon($breakpoint) {\n  @if $breakpoint==no-phone {\n    @media (min-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==phone {\n    @media (max-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==700px {\n    @media (max-width: 43.75em) {\n      //700px\n      @content;\n    }\n  }\n  @if $breakpoint==tab-port {\n    @media (max-width: 56.25em) {\n      //900px\n      @content;\n    }\n  }\n\n  @if $breakpoint==tab-land {\n    @media (max-width: 75em) {\n      //1200px\n      @content;\n    }\n  }\n  @if $breakpoint==big-desktop {\n    //1800px\n    @media (min-width: 112.5em) {\n      @content;\n    }\n  }\n}\n\n@mixin aspect-ratio($width, $height) {\n  position: relative;\n  overflow: hidden;\n  &:before {\n    display: block;\n    content: \"\";\n    width: 100%;\n    padding-top: ($height / $width) * 100%;\n  }\n  > * {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  }\n\n  > img {\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(398),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21d42449",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(394);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("0f5ab325", content, true, {});

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\nbutton[data-v-21d42449] {\n  border: none;\n}\n.progress-icon[data-v-21d42449] {\n  height: 24px;\n}\n.translations[data-v-21d42449] {\n  font: var(--medium-font);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 55%;\n  text-align: center;\n}\n.word[data-v-21d42449] {\n  border-bottom: 1px solid var(--color-primary);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 74px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.btn-remove[data-v-21d42449] {\n  border: 0.5px solid var(--color-primary);\n  font: var(--small-font);\n  border-radius: 14px;\n  padding: 4px;\n  margin: 0 10px;\n}\n.idx[data-v-21d42449] {\n  margin: 0 12px;\n  width: 0.5em;\n}\n.audio[data-v-21d42449] {\n  margin-right: 6px;\n  width: 1em;\n}\n.played-words[data-v-21d42449] {\n  margin-top: 20px;\n  width: 100%;\n}\n.saveWord[data-v-21d42449] {\n  fill: var(--button-primary-text);\n}\n.savedWord[data-v-21d42449] {\n  fill: var(--saved-word);\n}\n.blackBG-words[data-v-21d42449] {\n  background-color: var(--color-primary);\n  opacity: 0.4;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n.modal[data-v-21d42449] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-align: center;\n  z-index: 11;\n  background-color: var(--bg-primary);\n  opacity: 1;\n  padding: 12px;\n  border-radius: 4px;\n  max-width: 80vw;\n  /* transform: translate(-12%, 0); */\n  /* transform: translate(-50%, -50%); */\n  position: absolute;\n  top: 15%;\n  /* left: unset; */\n  /* right: 0; */\n  /* transform: none; */\n}\n.backBtn[data-v-21d42449] {\n  margin-bottom: 20px;\n}\n.btnSummry[data-v-21d42449] {\n  border-radius: 6px;\n  width: 100%;\n  font: var(--medium-font);\n}\n.btnRestart[data-v-21d42449] {\n  color: var(--button-primary-text);\n  background-color: var(--button-primary);\n}\n.btnGo[data-v-21d42449] {\n  color: var(--button-primary-text);\n  background-color: var(--button-primary);\n  margin-top: 8px;\n  height: 60px;\n}\n.btnRes[data-v-21d42449] {\n  color: var(--button-primary-text);\n  background-color: var(--button-primary);\n}\n.btnsDiv[data-v-21d42449] {\n  gap: 5px;\n  width: 100%;\n  height: 50px;\n}\n.divMistakes[data-v-21d42449] {\n  font: var(--medium-font);\n  text-align: left;\n}\n.square[data-v-21d42449] {\n  color: var(--color-primary-ltr);\n}\n.squareWrong[data-v-21d42449] {\n  color: var(--error-primary);\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Game-new/game-summary.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;EACE,aAAa;CACd;AACD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,WAAW;EACX,mBAAmB;CACpB;AACD;EACE,8CAA8C;EAC9C,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;AACD;EACE,yCAAyC;EACzC,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;EACb,eAAe;CAChB;AACD;EACE,eAAe;EACf,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,WAAW;CACZ;AACD;EACE,iBAAiB;EACjB,YAAY;CACb;AACD;EACE,iCAAiC;CAClC;AACD;EACE,wBAAwB;CACzB;AACD;EACE,uCAAuC;EACvC,aAAa;EACb,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,YAAY;CACb;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,uCAAuC;EACvC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,sBAAsB;CACvB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;CAC1B;AACD;EACE,kCAAkC;EAClC,wCAAwC;CACzC;AACD;EACE,kCAAkC;EAClC,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;CACd;AACD;EACE,kCAAkC;EAClC,wCAAwC;CACzC;AACD;EACE,SAAS;EACT,YAAY;EACZ,aAAa;CACd;AACD;EACE,yBAAyB;EACzB,iBAAiB;CAClB;AACD;EACE,gCAAgC;CACjC;AACD;EACE,4BAA4B;CAC7B","file":"game-summary.vue","sourcesContent":["\nbutton[data-v-21d42449] {\n  border: none;\n}\n.progress-icon[data-v-21d42449] {\n  height: 24px;\n}\n.translations[data-v-21d42449] {\n  font: var(--medium-font);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 55%;\n  text-align: center;\n}\n.word[data-v-21d42449] {\n  border-bottom: 1px solid var(--color-primary);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 74px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.btn-remove[data-v-21d42449] {\n  border: 0.5px solid var(--color-primary);\n  font: var(--small-font);\n  border-radius: 14px;\n  padding: 4px;\n  margin: 0 10px;\n}\n.idx[data-v-21d42449] {\n  margin: 0 12px;\n  width: 0.5em;\n}\n.audio[data-v-21d42449] {\n  margin-right: 6px;\n  width: 1em;\n}\n.played-words[data-v-21d42449] {\n  margin-top: 20px;\n  width: 100%;\n}\n.saveWord[data-v-21d42449] {\n  fill: var(--button-primary-text);\n}\n.savedWord[data-v-21d42449] {\n  fill: var(--saved-word);\n}\n.blackBG-words[data-v-21d42449] {\n  background-color: var(--color-primary);\n  opacity: 0.4;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n.modal[data-v-21d42449] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-align: center;\n  z-index: 11;\n  background-color: var(--bg-primary);\n  opacity: 1;\n  padding: 12px;\n  border-radius: 4px;\n  max-width: 80vw;\n  /* transform: translate(-12%, 0); */\n  /* transform: translate(-50%, -50%); */\n  position: absolute;\n  top: 15%;\n  /* left: unset; */\n  /* right: 0; */\n  /* transform: none; */\n}\n.backBtn[data-v-21d42449] {\n  margin-bottom: 20px;\n}\n.btnSummry[data-v-21d42449] {\n  border-radius: 6px;\n  width: 100%;\n  font: var(--medium-font);\n}\n.btnRestart[data-v-21d42449] {\n  color: var(--button-primary-text);\n  background-color: var(--button-primary);\n}\n.btnGo[data-v-21d42449] {\n  color: var(--button-primary-text);\n  background-color: var(--button-primary);\n  margin-top: 8px;\n  height: 60px;\n}\n.btnRes[data-v-21d42449] {\n  color: var(--button-primary-text);\n  background-color: var(--button-primary);\n}\n.btnsDiv[data-v-21d42449] {\n  gap: 5px;\n  width: 100%;\n  height: 50px;\n}\n.divMistakes[data-v-21d42449] {\n  font: var(--medium-font);\n  text-align: left;\n}\n.square[data-v-21d42449] {\n  color: var(--color-primary-ltr);\n}\n.squareWrong[data-v-21d42449] {\n  color: var(--error-primary);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__game_summary_scss__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__game_summary_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__game_summary_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_audioBtn_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_audioBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Shared_audioBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_userService__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_AudioPlayer_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_AudioPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Shared_AudioPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_VideoPlayer_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_VideoPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Shared_VideoPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Spacer_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Spacer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Shared_Spacer_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "game-summary",
  props: {
    playedItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    msg: {
      type: String,
      default: "עברו על המילים כדי להצליח בפעם הבאה"
    },
    currentData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      audioSrc: null,
      vidSrc: null,
      imgSrc: null,
      outText: null,
      allTranslationsHeight: [],
      text: "",
      results: false,
      isAutoPlay: true,
      ltr: localStorage.getItem("srcDirection") == "ltr"
    };
  },

  watch: {
    currentData: function currentData() {
      if (this.currentData.game.outro_image) this.imgSrc = this.currentData.game.outro_image;
      if (this.currentData.game.outro_audio) this.audioSrc = this.currentData.game.outro_audio;
      if (this.currentData.game.outro_video) this.vidSrc = this.currentData.game.outro_video;
      if (this.currentData.game.outro_text) this.outText = this.currentData.game.outro_text;
    },
    results: function results() {
      this.isAutoPlay = false;
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    savedWords: function savedWords() {
      if (this.user) {
        return this.user.saved_words.map(function (word) {
          return word.external_id;
        });
      } else {
        return [];
      }
    },
    orderedPlayedItems: function orderedPlayedItems() {
      return this.playedItems.sort(function (a, b) {
        return (a.wrong || 0) > (b.wrong || 0) ? -1 : 1;
      });
    }
  },
  methods: {
    makeLinkEmbaddable: function makeLinkEmbaddable(link) {
      if (String(link).includes("shorts")) {
        var _youtubeID = String(link).split("/shorts/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID + "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      if (String(link).includes(".be/")) {
        var _youtubeID2 = String(link).split(".be/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID2 + "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      var youtubeID = String(link).split("watch?v=")[1];
      return "https://www.youtube.com/embed/" + youtubeID + "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0";
    },
    isSaved: function isSaved(word) {
      if (word && this.savedWords.includes(word.id)) {
        return true;
      }
      return false;
    },
    restartGame: function restartGame() {
      this.$emit("restartGame");
    },
    goBack: function goBack() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // let thisLessonId = this.$store.getters.nextLesson.id
                // if (thisLessonId) {
                //   await userService.finishLesson(thisLessonId, this.user);
                // }

                _this.$router.push("/chapter/");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goNext: function goNext() {
      this.$router.push("/lesson/" + this.$store.getters.nextLesson.id + "/");
      // this.results = false;
    },
    saveWord: function saveWord(word) {
      if (!this.user) {
        // this.text = "עליך להתחבר על מנת לשמור מילים";
        this.text = this.$t("game-new.game-summery.msg1");
        return;
      }
      if (!this.isSaved(word)) {
        // this.text = `המילה ${word.heb}  נשמרה בהצלחה`;
        this.text = this.$t("game-new.game-summery.msg2") + ("" + word.heb);
        __WEBPACK_IMPORTED_MODULE_4__services_userService__["a" /* userService */].saveWord(word.id);
      } else {
        this.text = this.$t("game-new.game-summery.msg3") + ("" + word.heb);
        __WEBPACK_IMPORTED_MODULE_4__services_userService__["a" /* userService */].unsaveWord(word.id);
      }
    }
  },
  mounted: function mounted() {
    if (this.$refs.line) this.allTranslationsHeight = this.$refs.line.map(function (el) {
      return el.clientHeight;
    });
    if (this.currentData.game.outro_image) this.imgSrc = this.currentData.game.outro_image;
    if (this.currentData.game.outro_audio) this.audioSrc = this.currentData.game.outro_audio;
    if (this.currentData.game.outro_video) this.vidSrc = this.currentData.game.outro_video;
    if (this.currentData.game.outro_text) this.outText = this.currentData.game.outro_text;
  },

  components: {
    AudioBtn: __WEBPACK_IMPORTED_MODULE_3__Shared_audioBtn_vue___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_5__Shared_AudioPlayer_vue___default.a,
    VideoPlayer: __WEBPACK_IMPORTED_MODULE_6__Shared_VideoPlayer_vue___default.a,
    VideoPlayer1: __WEBPACK_IMPORTED_MODULE_6__Shared_VideoPlayer_vue___default.a,
    Spacer: __WEBPACK_IMPORTED_MODULE_7__Shared_Spacer_vue___default.a
  }
});

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(397);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("a5e27048", content, true, {});

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".game-summary{width:300px}.game-summary p{text-align:center}.game-summary .line{align-items:center;margin-bottom:10px}.game-summary .line .idx{flex:1}.mistakes{position:absolute;z-index:-1}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Game-new/src/components/Game-new/game-summary.scss"],"names":[],"mappings":"AACA,cAEE,WAAA,CACA,gBACE,iBAAA,CAEF,oBACE,mBACA,kBAAA,CACA,yBACE,MAAA,CAgBN,UACE,kBACA,UAAA,CAAA","file":"game-summary.scss","sourcesContent":["@import \"../../scss/abstracts/mixins\";\n.game-summary {\n  // min-height: 400px;\n  width: 300px;\n  p {\n    text-align: center;\n  }\n  .line {\n    align-items: center;\n    margin-bottom: 10px;\n    .idx {\n      flex: 1;\n    }\n\n    // .translations {\n    //   flex: 2;\n    //   .word {\n    //     overflow: hidden;\n    //     text-overflow: ellipsis;\n    //     width: 140px;\n    //     white-space: nowrap;\n    //   }\n    // }\n  }\n  // margin: 0 auto;\n}\n\n.mistakes {\n  position: absolute;\n  z-index: -1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-summary"
  }, [_c('div', {
    staticClass: "blackBG-words"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [(_vm.results) ? _c('div', {
    staticClass: "played-words"
  }, [(_vm.results) ? _c('div', {
    staticClass: "backBtn",
    on: {
      "click": function($event) {
        _vm.results = false
      }
    }
  }, [_c('inline-svg', {
    staticClass: "cup-svg saveWord",
    attrs: {
      "src": __webpack_require__(224).default
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t("game-new.game-summery.improve")))]), _vm._v(" "), _c('div', {
    staticClass: "divMistakes",
    style: ({
      textAlign: _vm.ltr ? 'left' : 'right'
    })
  }, [_vm._v("\n        " + _vm._s(_vm.$t("game-new.game-summery.mistakes")) + "\n      ")]), _vm._v(" "), _vm._l((_vm.orderedPlayedItems), function(word, idx) {
    return _c('div', {
      key: idx,
      staticClass: "word"
    }, [_c('div', {
      staticClass: "square",
      on: {
        "click": function($event) {
          return _vm.saveWord(word)
        }
      }
    }, [_c('inline-svg', {
      staticClass: "cup-svg saveWord",
      class: {
        savedWord: _vm.isSaved(word)
      },
      attrs: {
        "src": _vm.isSaved(word) ?
          __webpack_require__(215).default :
          __webpack_require__(226).default
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "audio"
    }, [_c('AudioBtn', {
      attrs: {
        "urlId": word.id
      }
    })], 1), _vm._v(" "), _c('div', {
      ref: "translations",
      refInFor: true,
      staticClass: "translations"
    }, [_c('div', {
      staticClass: "heb"
    }, [_vm._v(_vm._s(word.heb))]), _vm._v(" "), _c('div', {
      staticClass: "arbT arial"
    }, [_vm._v(_vm._s(word.Eng))]), _vm._v(" "), _c('div', {
      staticClass: "arb"
    }, [_vm._v(_vm._s(word.arb))])]), _vm._v(" "), _c('div', {
      staticClass: "square",
      class: {
        squareWrong: word.wrong
      }
    }, [_c('span', [_vm._v(_vm._s(word.wrong || "-"))])])])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('div', [_c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.outText))]), _vm._v(" "), (_vm.audioSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.audioSrc) ? _c('AudioPlayer', {
    attrs: {
      "audioSrc": _vm.audioSrc,
      "autoPlay": _vm.isAutoPlay
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('VideoPlayer1', {
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.vidSrc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('img', {
    attrs: {
      "id": "img",
      "src": _vm.imgSrc
    }
  }) : _vm._e(), _vm._v(" "), _c('Spacer', {
    attrs: {
      "height": "12"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('div', {
    staticClass: "flex btnsDiv"
  }, [_c('button', {
    staticClass: "btnSummry btnRestart",
    on: {
      "click": _vm.restartGame
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("game-new.game-summery.again")) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btnSummry btnRes",
    on: {
      "click": function($event) {
        _vm.results = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("game-new.game-summery.improve")) + "\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('button', {
    staticClass: "btnSummry btnGo",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("game-new.game-summery.next")) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(400)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(405),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78f9a78c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(401);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("5d35bd48", content, true, {});

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.game-header[data-v-78f9a78c] {\n  padding: 6px;\n  height: 60px;\n}\n.backarrowDiv[data-v-78f9a78c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-game[data-v-78f9a78c] {\n  margin: auto;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Game-new/game-header.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,aAAa;CACd;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,aAAa;CACd;AACD;EACE,aAAa;CACd","file":"game-header.vue","sourcesContent":["\n.game-header[data-v-78f9a78c] {\n  padding: 6px;\n  height: 60px;\n}\n.backarrowDiv[data-v-78f9a78c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-game[data-v-78f9a78c] {\n  margin: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__game_header_scss__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__game_header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__game_header_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_svgConfig__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(78);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GameHeader",
  props: ["currentData", "word", "trigger", "title", "progress", "total"],
  data: function data() {
    return {
      lessonName: this.$t("game-new.game-header.game"),
      arrowIconPath: {
        arrowIconNext: "",
        arrowIconPrevious: ""
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.arrowIconPath = Object(__WEBPACK_IMPORTED_MODULE_3__utils_svgConfig__["a" /* getArrowIconPath */])(localStorage.getItem("srcDirection"));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    wordRank: function wordRank() {
      try {
        this.word.qWord.know = this.word.qWord.know ? this.word.qWord.know : 0;
        //console.log(trigger);
        //console.log("wordRank", this.word.qWord);
        //this.word.aaa = "cba";
        //this.wordRank = this.word.qWord.know;
        return this.word.qWord.know;
      } catch (error) {
        console.log("ERROR", error);
        return 0;
      }
    }
  },
  watch: {
    currentData: function currentData() {
      console.log("I AM HERE");
      this.lessonName = this.currentData.name;
    },
    wordRank: function wordRank() {
      console.log("wordRank chnaged");
    },
    word: function word() {
      this.$forceUpdate();
      console.log("word changed");
    },
    progress: function progress() {
      var precent = this.progress / this.articleNum * 100;
      console.log(precent);
      document.getElementById('eng-progress-bar').style.width = precent + '%';
    }
  },
  updated: function updated() {
    console.log("UPDATED");
  },

  methods: {
    prevChapter: function prevChapter(event) {
      this.$router.push({
        path: "/chapter/"
      });
    }
  },
  components: {}
});

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(404);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("51439a1c", content, true, {});

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".game-header{display:grid;justify-content:space-between;background-color:var(--button-primary);padding:5px 5px;height:60px;grid-template-columns:15% 1fr 15%;align-items:center;justify-items:center}.game-header h2{text-align:center;font:var(--huge-font)}.game-titles{display:flex;flex-direction:column;align-items:center;justify-content:space-between}.game-titles h6{font:var(--medium-font);color:var(--button-primary-text)}.cup-svg{width:35px;height:35px}.arrow-svg-game{margin:auto;height:30px;fill:var(--button-primary-text);aspect-ratio:1/1}.disabled{fill:var(--color-disabled)}.eng-progress-container{background:var(--header-secondary-lt);height:10px;text-align:center;direction:ltr;font:var(--small-font);margin-bottom:100px}.eng-progress-bar{background:var(--progress-bar-primary);width:0;height:100%;-webkit-transition:width 1s ease-in-out;-moz-transition:width 1s ease-in-out;-o-transition:width 1s ease-in-out;transition:width 1s ease-in-out}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Game-new/src/components/Game-new/game-header.scss"],"names":[],"mappings":"AAEA,aACE,aACA,8BACA,uCACA,gBACA,YACA,kCACA,mBACA,oBAAA,CAEA,gBACE,kBACA,qBAAA,CAIJ,aACE,aACA,sBACA,mBACA,6BAAA,CACA,gBACE,wBACA,gCAAA,CAIJ,SACE,WACA,WAAA,CAEF,gBACE,YACA,YACA,gCACA,gBAAA,CAGF,UACE,0BAAA,CAGF,wBACE,sCACA,YACA,kBACA,cACA,uBACA,mBAAA,CAEF,kBACE,uCACA,QACA,YACA,wCACA,qCACA,mCACA,+BAAA,CAAA","file":"game-header.scss","sourcesContent":["@import \"../../scss//abstracts/variables\";\n\n.game-header {\n  display: grid;\n  justify-content: space-between;\n  background-color: var(--button-primary);\n  padding: 5px 5px;\n  height: 60px;\n  grid-template-columns: 15% 1fr 15%;\n  align-items: center;\n  justify-items: center;\n\n  h2 {\n    text-align: center;\n    font: var(--huge-font);\n  }\n}\n\n.game-titles {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  h6 {\n    font: var(--medium-font);\n    color: var(--button-primary-text);\n  }\n}\n\n.cup-svg {\n  width: 35px;\n  height: 35px;\n}\n.arrow-svg-game {\n  margin: auto;\n  height: 30px;\n  fill: var(--button-primary-text);\n  aspect-ratio: 1/1;\n}\n\n.disabled {\n  fill: var(--color-disabled);\n}\n\n.eng-progress-container {\n  background: var(--header-secondary-lt);\n  height: 10px;\n  text-align: center;\n  direction: ltr;\n  font: var(--small-font);\n  margin-bottom: 100px;\n}\n.eng-progress-bar {\n  background: var(--progress-bar-primary);\n  width: 0;\n  height: 100%;\n  -webkit-transition: width 1s ease-in-out;\n  -moz-transition: width 1s ease-in-out;\n  -o-transition: width 1s ease-in-out;\n  transition: width 1s ease-in-out;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 405:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "game-header"
  }, [_c('div', {
    staticClass: "backarrowDiv",
    on: {
      "click": _vm.prevChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-game",
    attrs: {
      "src": _vm.arrowIconPath.arrowIconPrevious
    }
  })], 1), _vm._v(" "), (_vm.trigger) ? _c('div', {
    staticClass: "game-titles"
  }, [(_vm.currentData) ? _c('h2', [_vm._v("\n        " + _vm._s(_vm.currentData.courseName) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.currentData) ? _c('h6', [_vm._v("\n        " + _vm._s(_vm.currentData ? _vm.currentData.name : _vm.$t("game-new.game-header.game")) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('h6', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eng-progress-container"
  }, [_c('div', {
    staticClass: "eng-progress-bar",
    attrs: {
      "id": "eng-progress-bar"
    }
  })])
}]}

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.chapter) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n    בטעינה...\n    "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', [_vm._v(_vm._s(_vm.$t("game-new.game-page.error")))]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.$t("game-new.game-page.back")))]) : _vm._e(), _vm._v(" "), (_vm.chapter) ? _c('div', {
    staticClass: "game-page"
  }, [_c('GameHeader', {
    attrs: {
      "currentData": _vm.data,
      "word": _vm.currentWord,
      "trigger": _vm.trigger,
      "title": _vm.title,
      "progress": _vm.progress,
      "total": _vm.playedItems
    }
  }), _vm._v(" "), (_vm.isSummary) ? _c('GameSummary', {
    attrs: {
      "msg": _vm.msg,
      "playedItems": _vm.currItems,
      "currentData": _vm.data
    },
    on: {
      "restartGame": _vm.restartGame
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSummary) ? _c('div', {
    staticClass: "word-game-main"
  }, [(_vm.question) ? _c('div', {
    staticClass: "question"
  }, [(_vm.question.qWord.id) ? _c('AudioBtn', {
    attrs: {
      "urlId": _vm.question.qWord.id,
      "autoplay": _vm.autoPlay,
      "idx": _vm.idx
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.question.onlyAudio && _vm.question.qWord.Eng) ? _c('span', {
    staticClass: "q"
  }, [_vm._v("\n          " + _vm._s(_vm.question.qWord.Eng))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.question) ? _c('ul', {
    staticClass: "answers grid"
  }, _vm._l((_vm.question.answers), function(answer) {
    return _c('li', {
      key: answer.objectID,
      class: {
        nope: _vm.choosenId && _vm.question.qWord.objectID !== answer.objectID,
        rightword: _vm.choosenId && _vm.question.qWord.objectID === answer.objectID,
        damnright: _vm.choosenId && _vm.question.qWord.objectID === answer.objectID,
        wrong: _vm.choosenId === answer.objectID &&
          _vm.question.qWord.objectID !== answer.objectID
      },
      on: {
        "click": function($event) {
          return _vm.checkAnswerA(answer, _vm.idx)
        }
      }
    }, [_vm._v("\n          " + _vm._s(answer.heb) + "\n        ")])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions-wrapper"
  }, [(_vm.showNext) ? _c('button', {
    staticClass: "btn-next",
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("game-new.game-page.next_q")) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showResults) ? _c('button', {
    staticClass: "btnSum",
    on: {
      "click": _vm.showSummary
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("game-new.game-page.summery")) + "\n      ")]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 2.ce03fd3d81a126f24b18.bundle.js